// extracted by mini-css-extract-plugin
export var projectPage = "ProjectPage-module--projectPage--ulUdX";